import o from "./components/branding/sgiCanadaLogo.mjs";
import r from "./components/branding/sgiLogo.mjs";
import m from "./components/disclosure/accordion.mjs";
import t from "./components/dataDisplay/badge.mjs";
import i from "./components/dataDisplay/card.mjs";
import e from "./components/dataDisplay/closeButton.mjs";
import p from "./components/dataDisplay/pagination.mjs";
import f from "./components/dataDisplay/table.mjs";
import a from "./components/dataDisplay/tag.mjs";
import n from "./components/dataDisplay/typography.mjs";
import l from "./components/disclosure/tabs.mjs";
import s from "./components/feedback/alert.mjs";
import u from "./components/feedback/notification.mjs";
import d from "./components/feedback/progress.mjs";
import g from "./components/feedback/responseError.mjs";
import c from "./components/feedback/spinner.mjs";
import b from "./components/feedback/skeleton.mjs";
import h from "./components/forms/autoSuggestion.mjs";
import { buttonTheme as T } from "./components/forms/button.mjs";
import S from "./components/forms/checkbox.mjs";
import C from "./components/forms/date-picker.mjs";
import v from "./components/forms/dualinput.mjs";
import y from "./components/forms/fileUpload.mjs";
import B from "./components/forms/form.mjs";
import F from "./components/forms/form-label.mjs";
import G from "./components/forms/form-error.mjs";
import P from "./components/forms/input.mjs";
import H from "./components/forms/number-input.mjs";
import I from "./components/forms/radio.mjs";
import k from "./components/forms/radioGroup.mjs";
import x from "./components/forms/select.mjs";
import A from "./components/forms/slider.mjs";
import L from "./components/forms/switch.mjs";
import M from "./components/forms/textarea.mjs";
import N from "./components/media/avatar.mjs";
import R from "./components/navigation/breadcrumb.mjs";
import D from "./components/navigation/globalFooter.mjs";
import E from "./components/navigation/globalHeader.mjs";
import U from "./components/navigation/globalHeaderv2.mjs";
import w from "./components/navigation/globalNavv2.mjs";
import V from "./components/navigation/link.mjs";
import { stepsTheme as j } from "./components/navigation/steps.mjs";
import { pageHeaderTheme as q } from "./components/navigation/pageHeader.mjs";
import z from "./components/other/close-button.mjs";
import { menuTheme as J } from "./components/overlay/menu.mjs";
import K from "./components/overlay/modal.mjs";
import O from "./components/overlay/popover.mjs";
import Q from "./components/overlay/tooltip.mjs";
import { footerTheme as W } from "./components/footer.mjs";
import X from "./components/globalNav.mjs";
import Y from "./components/helpButton.mjs";
import Z from "./foundations/index.mjs";
import _ from "./styles.mjs";
const $ = "ltr", oo = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "sgi"
}, rr = {
  ...Z,
  styles: _,
  components: {
    Accordion: m,
    Alert: s,
    AutoSuggestion: h,
    Avatar: N,
    Badge: t,
    Breadcrumb: R,
    Button: T,
    Card: i,
    Checkbox: S,
    CloseButton: z,
    CloseButtonCustom: e,
    DatePicker: C,
    DualInput: v,
    FileUpload: y,
    Footer: W,
    Form: B,
    FormError: G,
    FormLabel: F,
    GlobalFooter: D,
    GlobalHeader: E,
    GlobalHeaderv2: U,
    GlobalNav: X,
    GlobalNavv2: w,
    HelpButton: Y,
    Input: P,
    Link: V,
    Menu: J,
    Modal: K,
    Notification: u,
    NumberInput: H,
    PageHeader: q,
    Pagination: p,
    Progress: d,
    Radio: I,
    RadioGroup: k,
    ResponseError: g,
    SgiCanadaLogo: o,
    SgiLogo: r,
    Select: x,
    Skeleton: b,
    Slider: A,
    Spinner: c,
    Steps: j,
    Switch: L,
    Table: f,
    Tabs: l,
    Tag: a,
    Textarea: M,
    Tooltip: Q,
    Typography: n,
    Popover: O
  },
  config: oo,
  direction: $
};
export {
  rr as theme
};
